var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"download-pdf"},[_c('h2',{staticClass:"title--lighten"},[_vm._v("Скачать презентацию")]),_c('a',{attrs:{"href":"#","target":"_blank"}},[_c('i',{staticClass:"download-pdf__icon"})])])
}]

export { render, staticRenderFns }